import React from "react";
import { useGeneralContext } from "../contexts/GeneralContext";

const Header = () => {
        const generals = useGeneralContext();

        return (
                <div className="navbar">
                        <img src="../icon.png" className="nav-icon" />
                        <div className="nav-title">BAO <span className="lb-text">Portal</span></div>
                        <div className="nav-year">{generals.YEAR}</div>
                        {/* <div className="nav-year">{`${generals.YEAR}/${generals.YEAR % 100 + 1}`}</div> */}
                </div>
        );
}

export default Header;